<div class="group-goal-row" *ngIf="groupGoal">
    <div class="fields">
        <div class="gg-col">
            <!-- <div class="field-block-title">&nbsp;</div> -->
            <div class="field-block-value">
                <strong>{{ groupGoal.name }}</strong>
            </div>
        </div>
        <div class="gg-col" *ngIf="groupGoal.parentGroupGoal">
            <div class="field-block-title">{{ 'GROUP_GOAL_VIEW.LEADER_RELATED_TEAM_GOAL' | translate }}</div>
            <div class="field-block-value leader-group-goal">
                <ng-container>
                    <strong>{{ groupGoal.parentGroupGoal.employeeName }}:</strong> {{ groupGoal.parentGroupGoal.name }}
                </ng-container>
            </div>
        </div>
    </div>
    <div class="col-buttons">
        <button mat-icon-button color="primary" class="goal-delete hidden-print icon-button" [disabled]="!allowDelete()" (click)="onDelete()" title="{{ 'GROUP_GOAL_VIEW.DELETE' | translate }}">
            <mat-icon>delete</mat-icon>
        </button>
    </div>
</div>
